<div class="position-relative" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
	<ng-content></ng-content>
	<div @opacityAnimation *ngIf="open" class="position-absolute start-0 end-0 top-0 bottom-0 bg-opacity-50 bg-white">
		<ng-content select="[overlayContent]"></ng-content>
	</div>
</div>
